<mat-accordion>
  <mat-expansion-panel class="scheduled-task-summary" (opened)="expanded()">
    <mat-expansion-panel-header>
      <mat-panel-title><mat-icon>schedule</mat-icon>{{schedule.StartDate | date: 'dd/MM/yyyy HH:mm':'UTC'}} UTC</mat-panel-title>
      <mat-panel-description>
        <div>Tenants completed: {{schedule.StatusSummary.CompletedTenants}}/{{schedule.TotalTenants}}</div>
        <div>Overall status: <span class="overall-status" [class]="schedule.StatusSummary.OverallStatus">{{schedule.StatusSummary.OverallStatus}}</span></div>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <div class="task-summary-expansion-panel">
      <div class="status">
        @for (status of schedule.StatusSummary.TenantsByStatus; track status) {
          <div>
            <mat-accordion [togglePosition]="'before'">
              <mat-expansion-panel class="scheduled-task-summary-subpanel mat-elevation-z0">
                <mat-expansion-panel-header>
                  Tenants {{status.Status}}: {{status.Count}}
                </mat-expansion-panel-header>
                <div class="tenant-list">
                  @for (tenant of getTenantsForStatus(status.Status); track tenant) {
                    <div>
                      {{tenant.Name}}
                    </div>
                  }
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        }
      </div>
      <div class="config">
        <mat-form-field>
          <mat-label>Config</mat-label>
          <textarea matInput cdkTextareaAutosize disabled>{{schedule.TaskConfiguration | json}}</textarea>
        </mat-form-field>
      </div>
      <div>
        @if (canBeCancelled(schedule.StatusSummary.OverallStatus)) {
          <button mat-raised-button class="mat-primary" (click)="onCancel(schedule);">Cancel for remaining Tenants</button>
        }
      </div>
    </div>
  </mat-expansion-panel>
</mat-accordion>
